import Page from "@/components/layout/Page";

export default function HowProductsHelp() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6">How Products Help with Mobility & Calm</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Samboards are a UK developed company and manufacturers a range of sensory products which help with Sensory Activated motor-skills.
            </p>
            
            <p className="text-lg leading-relaxed">
              Our products are designed to reduce anxiety, manage stress, and keep focus. They support people living with ADHD, mental health conditions, wellbeing needs, dementia and stroke recovery through tactile sensory engagement.
            </p>
            
            <p className="text-lg leading-relaxed">
              The tactile nature of our sensory boards encourages fine motor movement and dexterity while providing calming sensory input. The different textures and surfaces help stimulate neural pathways, supporting both physical mobility and emotional regulation.
            </p>
            
            <p className="text-lg leading-relaxed">
              By engaging the sense of touch, our products help individuals self-regulate their emotions, improve concentration, and maintain focus during challenging tasks. The repetitive, soothing motions can help calm an overactive nervous system and provide a grounding focal point.
            </p>
            
            <p className="text-lg leading-relaxed">
              Whether used in educational settings, therapeutic environments, or at home, Samboards provide a simple yet effective tool for supporting both mobility development and emotional wellbeing.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
